module.exports = __WEBPACK_EXTERNAL_MODULE_106__;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 106
// module chunks = 0